import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

export const getBasicBusinessInfoView = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Reports/BasicBusinessInfoView`);
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch basic business info';
    }
};
